import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCannedResponses, createCannedResponse } from '../../store/Slices/supportSlice';

const CannedResponseManager = () => {
  const dispatch = useDispatch();
  const  user  = useSelector((state) => state.user.data);
  const { cannedResponses } = useSelector((state) => state.support);
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    dispatch(fetchCannedResponses());
  }, [dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(createCannedResponse({ title, message, created_by: user._id }));
    setTitle('');
    setMessage('');
  };

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
      <h1>إدارة الردود الجاهزة</h1>
      <form onSubmit={handleSubmit} style={{ marginBottom: '20px' }}>
        <div style={{ marginBottom: '15px' }}>
          <label>العنوان</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            style={{ width: '100%', padding: '8px', borderRadius: '4px' }}
            required
          />
        </div>
        <div style={{ marginBottom: '15px' }}>
          <label>الرسالة</label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            style={{ width: '100%', padding: '8px', borderRadius: '4px' }}
            required
          />
        </div>
        <button type="submit" style={{ padding: '10px 20px', backgroundColor: '#28a745', color: '#fff', borderRadius: '4px' }}>
          إضافة
        </button>
      </form>
      <h2>الردود الحالية</h2>
      {cannedResponses.map((response) => (
        <div key={response.id} style={{ border: '1px solid #ddd', padding: '10px', marginBottom: '10px', borderRadius: '4px' }}>
          <h3>{response.title}</h3>
          <p>{response.message}</p>
        </div>
      ))}
    </div>
  );
};

export default CannedResponseManager;